import { render, staticRenderFns } from "./identityPdf.vue?vue&type=template&id=60e06b0c&scoped=true"
import script from "./identityPdf.vue?vue&type=script&lang=js"
export * from "./identityPdf.vue?vue&type=script&lang=js"
import style0 from "./identityPdf.vue?vue&type=style&index=0&id=60e06b0c&prod&lang=scss&scoped=true"
import style1 from "./identityPdf.vue?vue&type=style&index=1&id=60e06b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e06b0c",
  null
  
)

export default component.exports